import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

api.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  const act = localStorage.getItem("act_tenant");
  if (act) cfg.headers["X-Tenant-Id"] = act;
  return cfg;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.data?.detail === "TENANT_UNAVAILABLE") {
      localStorage.removeItem("act_tenant");
      localStorage.removeItem("act_tenant_name");
      if (window.location.pathname !== "/platform") window.location.href = "/platform";
    }
    return Promise.reject(err);
  }
);

export const fileUrl = (id) =>
  id ? `${API}/files/${id}?auth=${localStorage.getItem("token")}` : null;

const TZ = "Asia/Singapore";
export const fmtTime = (iso) =>
  iso
    ? new Date(iso).toLocaleTimeString("en-SG", { timeZone: TZ, hour: "2-digit", minute: "2-digit", hour12: true })
    : "—";
export const fmtDate = (d) => {
  if (!d) return "—";
  const dt = typeof d === "string" && d.length === 10 ? new Date(d + "T00:00:00+08:00") : new Date(d);
  return dt.toLocaleDateString("en-SG", { timeZone: TZ, day: "2-digit", month: "short", year: "numeric" });
};
export const fmtMoney = (n) =>
  "$" + Number(n || 0).toLocaleString("en-SG", { minimumFractionDigits: 2, maximumFractionDigits: 2 });

export const apiErr = (e) => {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x.msg || JSON.stringify(x)).join(" ");
  return e?.message || "Something went wrong";
};

export const initials = (name) =>
  (name || "?")
    .split(" ")
    .map((p) => p[0])
    .slice(0, 2)
    .join("")
    .toUpperCase();
